/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbIcon } from "abreact/misc/AbIcon";
import { AbSize } from "abreact/misc/AbSize";
import * as React from "react";
export const GEE_INCOMPLETE_DATA_TEST_COMPONENT = "ab-gee-incomplete-indicator";
/**
 * Will either a span with an absdk-warning icon and a tooltip if incomplete
 * or an empty placeholder span
 * @param props
 * @constructor
 */
export function GEECompletenessIndicator(props) {
  if (!props.isComplete) {
    return /*#__PURE__*/React.createElement("span", {
      className: "ab-gee-validation-indicator-container",
      "data-test-component": "ab-gee-incomplete-indicator"
    }, /*#__PURE__*/React.createElement(AbIcon, {
      image: "absdk:warning",
      className: "ab-gee-incomplete-indicator",
      dataTestId: props.dataTestId && `${props.dataTestId}-incomplete-indicator`,
      size: AbSize.MEDIUM,
      tooltip: props.tooltip
    }));
  } else {
    return /*#__PURE__*/React.createElement("span", {
      className: "ab-gee-validation-indicator-container ab-gee-placeholder"
    });
  }
}
//# sourceMappingURL=GEECompletenessIndicator.js.map
